<template>
<v-app>
    <Navbar class="zoom-90" />
    <v-content :class="`${title != 'Usage' ? 'zoom-90' : ''}`" style="background: #f6f7fb;">
        <v-scale-transition :hide-on-leave="true">
            <v-container fluid>
                <router-view></router-view>
            </v-container>
        </v-scale-transition>
    </v-content>
    <!-- <Footer /> -->
</v-app>
</template>

<script>
import Navbar from '@/components/Layout/Navbar'
// import Footer from '@/components/Layout/Footer'
export default {
    components: {
        Navbar,
        // Footer
    },
    name: 'App',
    data() {
        return {
            title: ''
        }
    },
    mounted() {
        this.$watch(() => {
            this.title = this.$route.meta.title
        })
    },
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Questrial");

.v-application {
  font-family: "Questrial";
}
table.page-user-view td {
    vertical-align: top;
    min-width: 140px;
    padding: .5rem;
    word-break: break-all
}
</style>
